<template>
    <div class="large-container">
        <div class="w-full bg-view-sea-blue flex flex-col md:flex-row px-8 py-16 items-center rounded-sm gap-16">
            <div class="flex flex-col md:flex-row gap-16 items-center container">
                <ResponsiveImage
                    v-if="profilePicture"
                    :image-id="profilePicture"
                    sizes="(min-width: 1024px) 10.5rem, (min-width: 768px) 7.5rem, 13rem"
                    class="rounded-full max-w-52 w-full md:max-w-30 h-auto aspect-square lg:w-42 md:col-span-2 md:!col-start-1 md:justify-self-end lg:justify-self-center shrink-0 self-center object-center object-cover"
                />
                <div class="flex flex-col gap-8 item-center text-center md:text-left md:col-start-3 md:col-span-5 lg:col-span-4">
                    <div class="view-h3">{{leftSide?.title[mainStore.active_locale]}}</div>
                    <div>{{leftSide?.body[mainStore.active_locale]}}</div>
                    <div class="flex flex-col gap-0 underline">
                        <a v-for="link in leftSide?.links" :href="link.url">{{link.label}}</a>
                    </div>
                </div>
                <div class="flex flex-col gap-8 item-center text-center md:text-left md:!col-start-8 md:col-span-5 lg:col-span-4">
                    <div class="view-h3">{{rightSide?.title[mainStore.active_locale]}}</div>
                    <div>{{rightSide?.body[mainStore.active_locale]}}</div>
                    <div class="flex flex-col gap-0 underline">
                        <a v-for="link in rightSide?.links" :href="link.url">{{link.label}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>

import type { LocalizedText } from "#layers/cms/shared/types/bucketData"

const mainStore = useMainStore()
const { t, locale } = useI18n({useScope: 'local'})

const { profilePicture, leftSide, rightSide } = defineProps({
    profilePicture: String,
    leftSide: Object as PropType<{
        title: LocalizedText,
        body: LocalizedText,
        links: { label: string, url: string }[]
    }>,
    rightSide: Object as PropType<{
        title: LocalizedText,
        body: LocalizedText,
        links: { label: string, url: string }[]
    }>
})

</script>

<i18n lang="yaml">
en:
    contact-us: Contact us
nl:
    contact-us: Neem contact met ons op
</i18n>
